import {
  darkTheme,
  energeticTheme,
  freshTheme,
  lightTheme,
  naturalTheme,
  sereneTheme,
  trustfulTheme,
} from '../../../../../../styles';
import { getCookie } from '../../../../../../utils/cookie';

enum ThemeEnum {
  lightTheme,
  darkTheme,
  trustfulTheme,
  energeticTheme,
  naturalTheme,
  sereneTheme,
  freshTheme,
}

export default ThemeEnum;

export function getTheme(theme: ThemeEnum) {
  switch (theme) {
    case ThemeEnum.lightTheme:
      return lightTheme;
    case ThemeEnum.darkTheme:
      return darkTheme;
    case ThemeEnum.trustfulTheme:
      return trustfulTheme;
    case ThemeEnum.energeticTheme:
      return energeticTheme;
    case ThemeEnum.naturalTheme:
      return naturalTheme;
    case ThemeEnum.sereneTheme:
      return sereneTheme;
    case ThemeEnum.freshTheme:
      return freshTheme;
    default:
      return lightTheme;
  }
}

export function getThemeEnum() {
  const themeString = getCookie('theme');

  if (themeString == null || themeString === '') {
    return ThemeEnum.lightTheme;
  }

  const theme = parseInt(themeString);

  switch (theme) {
    case 0:
      return ThemeEnum.lightTheme;
    case 1:
      return ThemeEnum.darkTheme;
    case 2:
      return ThemeEnum.trustfulTheme;
    case 3:
      return ThemeEnum.energeticTheme;
    case 4:
      return ThemeEnum.naturalTheme;
    case 5:
      return ThemeEnum.sereneTheme;
    case 6:
      return ThemeEnum.freshTheme;
    default:
      return ThemeEnum.lightTheme;
  }
}
